import { render, staticRenderFns } from "./Profile.vue?vue&type=template&id=276c4716"
import script from "./profile.ts?vue&type=script&lang=ts&external"
export * from "./profile.ts?vue&type=script&lang=ts&external"
import style0 from "./profile.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports